import { render, staticRenderFns } from "./supplier-contact.vue?vue&type=template&id=d10a492a&"
import script from "./supplier-contact.vue?vue&type=script&lang=js&"
export * from "./supplier-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports